import chroma from "chroma-js";

function formatTimeAgo(dateString, getText) {
	if (!dateString) return "";

	const now = new Date();
	const givenDate = new Date(dateString);
	const diffMs = now - givenDate;

	const minutes = Math.floor(diffMs / 60000);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	const t = (key, fallback) =>
		typeof getText === "function" ? getText(key, fallback) : fallback;

	const tt = (primaryKey, legacyKey, fallback) => {
		const legacyFallback = typeof legacyKey === "string" ? t(legacyKey, fallback) : fallback;
		return t(primaryKey, legacyFallback);
	};

	if (days >= 1) {
		const label = days === 1
			? tt("time.day", "day", "day")
			: tt("time.days", "days", "days");

		return `${days} ${label} ${tt("time.ago", "ago", "ago")}`;
	}

	if (hours >= 1) {
		const hLabel = hours === 1
			? tt("time.hour", "hour", "hour")
			: tt("time.hours", "hours", "hours");

		const m = minutes % 60;
		const mLabel = m === 1
			? tt("time.minute", "minute", "minute")
			: tt("time.minutes", "minutes", "minutes");

		return `${hours} ${hLabel} ${m} ${mLabel} ${tt("time.ago", "ago", "ago")}`;
	}

	if (minutes >= 1) {
		const label = minutes === 1
			? tt("time.minute", "minute", "minute")
			: tt("time.minutes", "minutes", "minutes");

		return `${minutes} ${label} ${tt("time.ago", "ago", "ago")}`;
	}

	return t("time.just_now", t("just_now", "Just now"));
}

const trimString = (str, len) => {
	try {
		if (str.length <= len) {
			return str;
		}
		return str.slice(0, len) + '...';
	} catch (error) {
		console.error("@@ Error: trimString @@", error);
		return "";
	}
};

const generateFuturisticGradient = (baseColor, neonColor = "#6257ff") => {
	// Generate shades from the base color
	const darkShade = chroma(baseColor).darken(1.5).hex(); // Darker variation
	const lightShade = chroma(baseColor).brighten(1.5).hex(); // Lighter variation
	const neonEffect = chroma.mix(baseColor, neonColor, 0.5).hex(); // Cyan neon mix

	// Create a smooth futuristic gradient
	return `linear-gradient(135deg, ${darkShade}, ${baseColor}, ${neonEffect}, ${lightShade})`;
};

//Configure wvs domain based on the environment it is running in
function getVoiceWidgetDomain() {
	const hostDomain = window.location.hostname;
	if (hostDomain.includes("stage")) {
		return 'https://stage-voice.intelswift.com';
	} else if (hostDomain.includes("localhost")) {
		return 'http://localhost:3003';
	} else {
		return 'https://voice.intelswift.com';
	}
}

const getInitials = (name) => {
	if (!name || typeof name !== 'string') return '';
	const parts = name.trim().split(/\s+/);
	if (parts.length === 1) {
		return parts[0].charAt(0).toUpperCase();
	}
	return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const formatDate = (dateString, getText) => {
	if (!dateString) return "";

	const t = (key, fallback) =>
		typeof getText === "function" ? getText(key, fallback) : fallback;

	const tt = (primaryKey, legacyKey, fallback) => {
		const legacyFallback = typeof legacyKey === "string" ? t(legacyKey, fallback) : fallback;
		return t(primaryKey, legacyFallback);
	};

	try {
		const date = new Date(dateString);
		const now = new Date();
		const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

		if (diffInDays === 0) return tt("time.today", "today", "Today");
		if (diffInDays === 1) return tt("time.yesterday", "yesterday", "Yesterday");

		if (diffInDays < 7) {
			return `${diffInDays} ${
				diffInDays === 1 ? tt("time.day", "day", "day") : tt("time.days", "days", "days")
			} ${tt("time.ago", "ago", "ago")}`;
		}

		const d = String(date.getDate()).padStart(2, "0");
		const m = String(date.getMonth() + 1).padStart(2, "0");

		if (date.getFullYear() !== now.getFullYear()) {
			return `${d}.${m}.${date.getFullYear()}`;
		}

		return `${d}.${m}`;
	} catch (error) {
		console.error("@@ Error: formatDate @@", error);
		return "";
	}
};

export {
	formatTimeAgo,
	trimString,
	generateFuturisticGradient,
	getVoiceWidgetDomain,
	getInitials,
	formatDate
};